<aside class="private-task-rail">
  <div class="private-task-rail__composer">
    <input
      nz-input
      [(ngModel)]="newTitle"
      [placeholder]="'privateTaskRail.quickAddPlaceholder' | translate"
      (keydown.enter)="createTask()"
    />
    <button class="desktop-button" nz-button nzType="primary" type="button" [disabled]="!newTitle.trim() || creating()" (click)="createTask()">
      <i nz-icon [nzType]="creating() ? 'loading' : 'plus'"></i>
      {{ 'privateTaskRail.add' | translate }}
    </button>
  </div>

  <div *ngIf="loading()" class="private-task-rail__loading">
    <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 5 }"></nz-skeleton>
  </div>

  <div *ngIf="!loading() && tasks().length === 0" class="private-task-rail__empty">
    <nz-empty nzNotFoundImage="simple" [nzNotFoundContent]="'privateTaskRail.empty' | translate"></nz-empty>
  </div>

  <div *ngIf="!loading() && tasks().length > 0" class="private-task-rail__list">
    <div
      class="private-task-rail__drop-list"
      cdkDropList
      cdkDropListLockAxis="y"
      [cdkDropListData]="tasks()"
      [class.private-task-rail__drop-list--dragging]="draggingTaskId() !== null"
      (cdkDropListDropped)="drop($event)"
    >
      <article
        *ngFor="let task of tasks(); trackBy: trackTask"
        class="private-task-rail__card"
        [class.private-task-rail__card--dragging]="draggingTaskId() === task.inboxTaskId"
        (dblclick)="openTask(task)"
        cdkDrag
        cdkDragLockAxis="y"
        [cdkDragStartDelay]="dragStartDelay"
        (cdkDragStarted)="onDragStarted(task, $event)"
        (cdkDragEnded)="onDragEnded($event)"
      >
        <div class="private-task-rail__card-top">
          <div class="private-task-rail__card-main">
            <h3 class="private-task-rail__card-title">{{ task.title }}</h3>
            <div
              class="private-task-rail__badges"
              *ngIf="showPriority(task) || isCompleted(task)"
            >
              <span
                *ngIf="showPriority(task)"
                class="private-task-rail__pill"
                [attr.data-intent]="priorityTone(task)"
              >
                <ng-container *ngIf="priorityIcon(task) as priorityIconName">
                  <i nz-icon [nzType]="priorityIconName"></i>
                </ng-container>
                {{ priorityLabel(task) }}
              </span>
              <span *ngIf="isCompleted(task)" class="private-task-rail__pill private-task-rail__pill--done">
                <i nz-icon nzType="check"></i>
                {{ 'privateTaskRail.status.done' | translate }}
              </span>
            </div>
          </div>

          <div class="private-task-rail__card-tools">
            <span *ngIf="task.dueAt" class="private-task-rail__due">
              <i nz-icon nzType="calendar"></i>
              {{ task.dueAt | date: 'dd.MM.yy' }}
            </span>

            <button
              nz-button
              nzType="primary"
              nzSize="small"
              type="button"
              class="private-task-rail__open  desktop-button"
              (click)="openTask(task); $event.stopPropagation()"
              [attr.aria-label]="'privateTaskRail.open' | translate"
            >
              {{ 'privateTaskRail.open' | translate }}
            </button>
          </div>
        </div>

        <p *ngIf="task.description" class="private-task-rail__description">{{ task.description }}</p>
      </article>
    </div>
  </div>
</aside>
